<template>
  <b-button type="is-primary" class="copyButton" @click="copyText()">
    <font-awesome-icon :icon="['fas', 'clipboard']" />
    {{ $t("message.copy_btn") }}
  </b-button>
</template>

<script>
export default {
  name: "ButtonCopy",
  methods: {
    // select the text to copy
    selectText(element) {
      var range;
      // for Internet Explorer
      if (document.selection) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copyText() {
      // copy the text to clipboard - the $parent property is needed to access the parent instance
      this.selectText(this.$parent.$refs.text);
      try {
        document.execCommand("copy");
        // if copy is successful, send success notification
        this.$buefy.toast.open({
          message: `${this.$t("message.copy_success_text")}`,
          type: "is-success"
        });
      } catch (error) {
        // if copy fails, post error notification
        this.$buefy.toast.open({
          message: `${this.$t("message.copy_error_text")}`,
          type: "is-danger"
        });
      }
    }
  } // end methods
};
</script>

<style></style>
